module.exports = __webpack_public_path__ + "static/img/honor10.1558cb5.png";


//////////////////
// WEBPACK FOOTER
// ./public/aboutusImg/honor10.png
// module id = 8nqH
// module chunks = 0